import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import {
  Form,
  CardHolderElement,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  CardInstallmentElement,
  useFanthon,
  useElements,
} from "./main";

import "./index.css";

function CardForm({ fields }) {
  const { theme = "", number, installment_options = [] } = JSON.parse(
    fields?.fields?.replace(/^'/, "")?.replace(/'$/, "") ?? "{}",
  );

  const fanthon = useFanthon();
  const [elements] = useElements();
  const [event, setEvent] = useState({});
  useEffect(() => {
    window.addEventListener("message", function(event) {
      console.info(event);
      if (!fanthon || !elements) return;
      if (event.data !== "click") return;

      setEvent(event);
      setTimeout(() => {
        window.document.getElementById("fanthon_submit_click").click();
      }, 1);
    });
    return () => {
      window.removeEventListener("message", {});
    };
  }, []);

  const isDisabled = React.useMemo(() => {
    const keys = Object.keys(elements);
    const data = !keys.every((key) => elements[key].complete === true);
    return data;
  }, [elements]);

  const onSubmit = async (secure) => {
    if (!event) return;
    if (isDisabled) return console.error("campos inválidos");

    const { source = {}, origin } = event || {};

    try {
      const { errors, payment_method } = await fanthon.createPaymentMethod({
        secure,
        elements,
        params: {
          billing_details: {
            name: elements?.holder?.holder || "Principal",
            address: {
              line1: null,
              line2: null,
              postal_code: null,
              state: null,
              city: null,
              country: null,
            },
          },
        },
      });
      source?.postMessage({ payment_method, errors }, origin);
    } catch (error) {
      source?.postMessage({ payment_method: null, errors: [error] }, origin);
    }
  };

  const containerClassname =
    theme && theme === "dark" ? "dark_mode" : "light_mode";
  return (
    <div className={containerClassname}>
      <Form onSubmit={onSubmit}>
        <Row gutter={16}>
          <Col span={24}>
            <CardHolderElement
              options={fields?.holder}
              onChange={({ elementType, complete, errors, holder }) =>
                console.info(elementType, complete, errors, holder)
              }
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <CardNumberElement
              options={number}
              // options={{ showIcon: true }}
              onChange={({
                elementType,
                complete,
                errors,
                bank_identification_number,
              }) =>
                console.log(
                  elementType,
                  complete,
                  errors,
                  bank_identification_number,
                )
              }
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={16}>
            <CardExpiryElement
              options={fields?.expire}
              onChange={({
                elementType,
                complete,
                errors,
                exp_month,
                exp_year,
              }) =>
                console.info(elementType, complete, errors, exp_month, exp_year)
              }
            />
          </Col>
          <Col span={8}>
            <CardCvcElement
              options={fields?.cvv}
              onChange={({ elementType, complete, errors }) =>
                console.info(elementType, complete, errors)
              }
            />
          </Col>

          {!!installment_options?.length && (
            <Col span={8}>
              <CardInstallmentElement
                options={fields?.cvv}
                onChange={({ elementType, installment, complete, errors }) =>
                  console.info(elementType, installment, complete, errors)
                }
                installment_options={installment_options}
              />
            </Col>
          )}
        </Row>

        <button
          type="submit"
          style={{ display: "none" }}
          id="fanthon_submit_click"
        >
          click
        </button>
      </Form>
    </div>
  );
}

export default CardForm;
